<template>
  <div class="return_visit">
    <el-drawer
      title="新增回访"
      :visible.sync="dialogdata"
      direction="rtl"
      :wrapperClosable="false"
      size="60%"
      @open="openDialog"
      @close="close"
    >
      <div>
        <div style="margin-top: -20px">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1" style="font-size: 16px">回访</el-menu-item>
            <el-menu-item index="2" style="font-size: 16px"
              >历史回访记录({{ totalNum }})</el-menu-item
            >
            <el-menu-item
              index="3"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1566') : false
              "
              style="font-size: 16px"
              >短信({{ smsLogTableData.length }})</el-menu-item
            >
          </el-menu>
        </div>
        <div class="container return_visit" v-if="active == 1">
          <!-- 医生信息 -->
          <div v-if="visitType != 2">
            <div class="title">医生信息</div>
            <div class="box">
              <div class="align-center">
                <span class="item">
                  <span class="gray_long"> 医生： </span>
                  <span>{{ doctor_info.doctor_name }}</span>
                </span>
                <span class="item">
                  <span class="gray_long"> 医生手机号： </span>
                  <span>{{ doctor_info.phone }}</span>
                </span>
                <img
                  v-if="
                    doctor_info.phone &&
                    (module_id_array[0]
                      ? module_id_array.includes('1756')
                      : true)
                  "
                  class="phone-box"
                  src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                  alt
                  @click="callBtn(1, doctor_info.doctor_id)"
                />
                <!-- <span class="item">
                  <span class="gray_long"> 注册时间： </span>
                  <span>{{ doctor_info.create_time }}</span>
                </span> -->
                <!-- <span class="item">
                  <span class="gray_long"> 认证时间： </span>
                  <span>{{ doctor_info.auth_time }}</span>
                </span> -->
              </div>
              <div class="flex" style="margin: 10px 0">
                <span class="item">
                  <span class="gray_long"> 医生的客服备注： </span>
                  <span>{{ doctor_info.doc_remark }}</span>
                </span>
              </div>
              <div class="flex">
                <span>
                  <span class="gray_long"> 医生药房打印备注： </span>
                  <span>{{ doctor_info.hospital_print_remark }}</span>
                </span>
              </div>
              <div class="flex" style="margin-top: 10px">
                <span>
                  <span class="gray_long"> 推荐人： </span>
                  <span>{{ doctor_info.recommender_name }}</span>
                </span>
                <span>
                  <span class="gray_long"> 推荐人手机号： </span>
                  <span>{{ doctor_info.re_phone }}</span>
                </span>
                <img
                  v-if="
                    doctor_info.re_phone &&
                    (module_id_array[0]
                      ? module_id_array.includes('1756')
                      : true)
                  "
                  class="phone-box"
                  src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                  alt
                  @click="callBtn(2, doctor_info.doctor_id)"
                />
                <!-- <span>
                  <span class="gray_long"> 客服标签： </span>
                  <span>{{ doctor_info.customer_service_label }}</span>
                </span> -->
              </div>
            </div>
          </div>
          <!-- 患者信息 -->
          <div v-if="visitType != 1">
            <div class="title">患者信息</div>
            <div class="box">
              <div class="flex">
                <span class="item">
                  <span class="gray"> 患者名字： </span>
                  <span>{{ patient_info.real_name }}</span>
                </span>
                <span class="item">
                  <span class="gray"> 性别： </span>
                  <span v-if="patient_info.sex == 1">男</span>
                  <span v-if="patient_info.sex == 2">女</span>
                  <span v-if="patient_info.sex == 0">未知</span>
                </span>
                <span class="item">
                  <span class="gray"> 年龄： </span>
                  <span>{{ patient_info.age }}</span>
                </span>
                <!-- <span class="item">
                  <span class="gray_long"> 关系（是用户的）： </span>
                  <span v-if="patient_info.relationship == 1">本人</span>
                  <span v-if="patient_info.relationship == 2">爸爸</span>
                  <span v-if="patient_info.relationship == 3">妈妈</span>
                  <span v-if="patient_info.relationship == 4">老公</span>
                  <span v-if="patient_info.relationship == 5">老婆</span>
                  <span v-if="patient_info.relationship == 6">女儿</span>
                  <span v-if="patient_info.relationship == 7">儿子</span>
                  <span v-if="patient_info.relationship == 8">朋友</span>
                  <span v-if="patient_info.relationship == 9">家人</span>
                </span> -->
              </div>
              <div class="flex" style="margin: 10px 0">
                <span class="item">
                  <span class="gray"> 用户昵称： </span>
                  <span>{{ patient_info.nick_name }}</span>
                </span>
                <!-- <span class="item">
                  <span class="gray"> 用户真实姓名： </span>
                  <span>{{ patient_info.user_real_name }}</span>
                </span> -->
                <span class="item">
                  <span class="gray_long"> 用户绑定手机号： </span>
                  <span>{{ patient_info.phone }}</span>
                </span>
                <img
                  v-if="
                    patient_info.phone &&
                    (module_id_array[0]
                      ? module_id_array.includes('1756')
                      : true)
                  "
                  class="phone-box"
                  src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                  alt
                  @click="callBtn(3, patient_info.patient_id)"
                />
              </div>
              <!-- <div class="flex">
                <span class="item">
                  <span class="gray"> 客服标签： </span>
                  <span>{{ patient_info.customer_service_label }}</span>
                </span>
              </div> -->
            </div>
          </div>
          <!-- 处方订单信息 -->
          <div v-if="visitType == 3">
            <div class="title">处方/订单信息</div>
            <div class="box">
              <div class="flex">
                <span class="item">
                  <span class="gray"> 处方号： </span>
                  <span>{{ pre_info.pre_id }}</span>
                </span>
                <span class="item">
                  <span class="gray"> 处方来源： </span>

                  <span v-if="pre_info.pre_type == 1">咨询开方</span>
                  <span v-if="pre_info.pre_type == 2">在线开方</span>
                  <span v-if="pre_info.pre_type == 3">重新开方</span>
                  <span v-if="pre_info.pre_type == 4">云诊所开方</span>
                  <span v-if="pre_info.pre_type == 5">手机号开方</span>
                  <span v-if="pre_info.pre_type == 6">微信开方</span>
                  <span v-if="pre_info.pre_type == 7">视频问诊开方</span>
                  <span v-if="pre_info.pre_type == 8">按方购药</span>
                  <span v-if="pre_info.pre_type == 9">拍方购药</span>
                  <span v-if="pre_info.pre_type == 10">开放平台开方</span>
                  <span v-if="pre_info.pre_type == 11">医生拍照开方</span>
                  <span v-if="pre_info.pre_type == 12">医生协定方开方</span>
                  <span v-if="pre_info.phone">（{{ pre_info.phone }}）</span>
                </span>
                <span class="item">
                  <span class="gray"> 处方状态： </span>
                  <span v-if="pre_info.status == 1">待取药</span>
                  <span v-if="pre_info.status == 2">待审方</span>
                  <span v-if="pre_info.status == 3">已通过</span>
                  <span v-if="pre_info.status == 4">已抓药</span>
                  <span v-if="pre_info.status == 5">已失效</span>
                  <span v-if="pre_info.status == 6">已失效</span>
                  <span v-if="pre_info.status == 7">已失效</span>
                  <span v-if="pre_info.status == 8">已失效</span>
                </span>
                <span class="item">
                  <span class="gray"> 合计金额： </span>
                  <span>{{ pre_info.pay_money }}</span>
                </span>
              </div>
              <div class="flex" style="margin: 10px 0">
                <span class="item">
                  <span class="gray"> 订单编号： </span>
                  <span>{{ pre_info.order_sn }}</span>
                </span>
                <span class="item">
                  <span class="gray"> 订单状态： </span>
                  <span v-if="pre_info.order_status == 1">待审核</span>
                  <span v-if="pre_info.order_status == 2">待发药</span>
                  <span v-if="pre_info.order_status == 3">待收货</span>
                  <span v-if="pre_info.order_status == 4">已完成</span>
                  <span v-if="pre_info.order_status == 5">不通过</span>
                  <span v-if="pre_info.order_status == 6">已失效</span>
                </span>
                <span class="item">
                  <span class="gray"> 配送方式： </span>
                  <span v-if="pre_info.delivery == 1">快递</span>
                  <span v-if="pre_info.delivery == 2">自提</span>
                  <span v-if="pre_info.delivery == 3">闪送</span>
                </span>
              </div>
              <div class="flex">
                <span v-if="pre_info.delivery != 2">
                  <span class="gray"> 收货人： </span>
                  <span>{{ pre_info.consignee_name }}</span>
                </span>
                <span style="margin: 0 20px" v-if="pre_info.delivery != 2">
                  <span class="gray"> 收货人电话： </span>
                  <span>{{ pre_info.consignee_phone }}</span>
                </span>
                <img
                  v-if="
                    pre_info.consignee_phone &&
                    (module_id_array[0]
                      ? module_id_array.includes('1756')
                      : true)
                  "
                  class="phone-box"
                  src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                  alt
                  @click="callBtn(4, pre_info.pre_id)"
                />
                <span class="item">
                  <span class="gray" style="width: 120px">
                    自提/收货人地址：
                  </span>
                  <span>{{ pre_info.address }}</span>
                </span>
              </div>
            </div>
          </div>
          <!-- 患者近期处方 -->
          <div v-if="visitType == 3">
            <div class="title">患者近期处方</div>
            <div class="box" style="padding-bottom: 0px">
              <div
                class="flex"
                style="margin-bottom: 10px"
                v-for="(item, index) in patient_pre_info"
                :key="index"
              >
                <div style="width: 200px">
                  <span class="gray">处方号：</span>
                  <span>{{ item.pre_id }}</span>
                </div>
                <div style="width: 280px">
                  <span class="gray">开方时间：</span>
                  <span>{{ item.create_time }}</span>
                </div>
                <span class="gray">处方状态：</span>
                <span v-if="item.status == 1">待取药</span>
                <span v-if="item.status == 2">待审方</span>
                <span v-if="item.status == 3">已通过</span>
                <span v-if="item.status == 4">已抓药</span>
                <span v-if="item.status == 5">过期未取药</span>
                <span v-if="item.status == 6">审方不通过</span>
                <span v-if="item.status == 7">医生手动作废</span>
                <span v-if="item.status == 8">平台退款</span>
              </div>
            </div>
          </div>
          <!-- 咨询信息 -->
          <div v-if="visitType == 4">
            <div class="title">咨询信息</div>
            <div class="box">
              <div class="flex">
                <span class="item">
                  <span class="gray"> 问诊时间： </span>
                  <span>{{ consult_info.submit_time }}</span>
                </span>
                <span class="item">
                  <span class="gray"> 接诊时间： </span>
                  <span>{{ consult_info.agree_time }}</span>
                </span>
              </div>
              <div class="flex" style="margin: 10px 0">
                <span class="item">
                  <span class="gray"> 问诊费用： </span>
                  <span>{{ consult_info.pay_money }}</span>
                </span>
                <span class="item">
                  <span class="gray"> 问诊状态： </span>
                  <span>
                    {{ consult_info.status | consultInfoStatusText }}</span
                  >
                </span>
                <span class="item">
                  <span class="gray"> 问诊类型： </span>
                  <span
                    v-if="
                      consult_info.consult_type == 1 &&
                      consult_info.consult_types == 1
                    "
                    >患者问诊</span
                  >
                  <span v-if="consult_info.consult_type == 2">医生赠送</span>
                  <span v-if="consult_info.consult_type == 3">诊后咨询</span>
                  <span v-if="consult_info.consult_type == 4">预约视频</span>
                  <span
                    v-if="
                      consult_info.consult_type == 1 &&
                      consult_info.consult_types == 2
                    "
                    >视频问诊</span
                  >
                  <span
                    v-if="
                      consult_info.consult_type == 1 &&
                      consult_info.consult_types == 3
                    "
                    >电话问诊</span
                  >
                </span>
              </div>
              <div class="flex">
                <span class="item">
                  <span class="gray"> 结束时间： </span>
                  <span>{{ consult_info.over_time }}</span>
                </span>
                <span
                  class="item"
                  v-if="
                    consult_info.status != 1 &&
                    consult_info.status != 2 &&
                    consult_info.status != 3
                  "
                >
                  <span class="gray"> 结束类型： </span>
                  <span>
                    {{ consult_info.status | consultInfoStatusText }}</span
                  >
                </span>
              </div>
            </div>
          </div>

          <div class="title">新增回访</div>
          <div>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="140px"
              class="demo-ruleForm"
            >
              <el-form-item label="回访人员">
                {{ user_name }}
              </el-form-item>
              <el-form-item label="回访类型" style="margin-top: -15px">
                <span v-if="visitType == 1">医生</span>
                <span v-if="visitType == 2">患者</span>
                <span v-if="visitType == 3">处方/订单</span>
                <span v-if="visitType == 4">咨询</span>
              </el-form-item>
              <el-form-item label="回访对象" prop="return_object">
                <el-select
                  v-model="ruleForm.return_object"
                  placeholder="请选择"
                  class="input_width"
                  @change="changeObject"
                >
                  <el-option
                    v-if="visitType != 2"
                    :label="'医生(' + doctor_info.doctor_name + ')'"
                    :value="1"
                  ></el-option>
                  <el-option
                    v-if="visitType != 1"
                    :label="'患者(' + patient_info.real_name + ')'"
                    :value="2"
                  ></el-option>
                  <el-option
                    v-if="visitType != 2 && doctor_info.recommender_name"
                    :label="'推荐人(' + doctor_info.recommender_name + ')'"
                    :value="3"
                  ></el-option>
                  <el-option
                    v-if="visitType == 3"
                    label="药房"
                    :value="4"
                  ></el-option>
                  <el-option
                    v-if="visitType == 3"
                    label="物流"
                    :value="5"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="回访来源" prop="return_from" required="">
                <el-select
                  v-model="ruleForm.return_from"
                  placeholder="请选择"
                  class="input_width"
                >
                  <el-option label="主动" :value="1"></el-option>
                  <el-option label="被动" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="回访方式" prop="visit_type">
                <el-radio-group v-model="ruleForm.visit_type">
                  <el-radio
                    :label="item.method"
                    v-for="(item, index) in methodList"
                    :key="index"
                    >{{ item.method }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="处理问题类型" prop="solving_type">
                <el-select
                  v-model="ruleForm.solving_type"
                  placeholder="请选择"
                  class="input_width"
                >
                  <el-option
                    v-for="item in problemList"
                    :key="item.problem_type"
                    :label="item.problem_type"
                    :value="item.problem_type"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="回访原因" style="margin-bottom: 45px">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入回访原因"
                  v-model="ruleForm.desc"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="回访结果"
                style="margin-bottom: 40px"
                prop="treatment_method"
              >
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入解决方案及回访结果"
                  v-model="ruleForm.treatment_method"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
              <!-- <el-form-item label="是否需要继续回访"
                            prop="is_on_return"
                            required="">
                <el-radio-group v-model="ruleForm.is_on_return">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="下次回访时间"
                            prop="next_time"
                            v-if="ruleForm.is_on_return == 1">
                <el-date-picker v-model="ruleForm.next_time"
                                type="date"
                                placeholder="选择日期"
                                class="input_width"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item> -->
              <el-form-item label="标记为已回访类型" prop="return_type_min">
                <el-select
                  class="input_width"
                  v-model="ruleForm.return_type_min"
                  placeholder="请选择"
                >
                  <template v-for="item in typeListData">
                    <el-option
                      v-if="item.visit_type != 0"
                      :key="item.visit_type"
                      :label="item.value"
                      :value="item.visit_type"
                    >
                    </el-option>
                  </template>
                </el-select>
              </el-form-item>

              <el-form-item
                label="客服标签"
                prop="label"
                v-if="
                  ruleForm.return_object == 1 || ruleForm.return_object == 2
                "
              >
                <el-select
                  size="medium"
                  v-model="ruleForm.visit_label"
                  placeholder="请选择"
                  style="width: 400px"
                  multiple=""
                >
                  <el-option
                    v-for="item in ruleForm.return_object == 1
                      ? doctorLabel
                      : patientLabel"
                    :key="item.label_id"
                    :label="item.label_name"
                    :value="item.label_name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div style="text-align: center; margin-top: 40px">
              <el-button
                plain
                @click="submit('ruleForm', 1)"
                style="width: 92px"
                size="medium"
                >保 存</el-button
              >
              <el-button
                type="primary"
                @click="submit('ruleForm', 2)"
                size="medium"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1315') : false
                "
                >保存并继续填写</el-button
              >
            </div>
          </div>
          <div></div>
        </div>
        <div class="container" v-if="active == 2">
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column label="回访人员" prop="visit_name">
              </el-table-column>
              <el-table-column label="回访时间" prop="create_time" width="100">
              </el-table-column>
              <el-table-column label="回访对象">
                <template slot-scope="scope">
                  <span>{{ scope.row.return_object_str }}</span>
                  <div v-if="scope.row.return_business_name">
                    ({{ scope.row.return_business_name }})
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="回访来源">
                <template slot-scope="scope">
                  <span v-if="scope.row.return_from == 1">主动</span>
                  <span v-if="scope.row.return_from == 2">被动</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="visit_type"
                label="回访方式"
              ></el-table-column>
              <el-table-column
                prop="solving_type"
                label="处理问题类型"
              ></el-table-column>
              <el-table-column prop="desc" label="回访原因"></el-table-column>

              <el-table-column prop="treatment_method" label="回访结果">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    :content="scope.row.treatment_method"
                    effect="dark"
                    placement="top-start"
                  >
                    <div class="clamp-line">
                      {{ scope.row.treatment_method }}
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>

              <el-table-column prop="is_return" label="标记为已回访类型">
              </el-table-column>
              <el-table-column prop="label" label="客服标签"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="container" v-if="active == 3">
          <el-button
            v-if="this.sms_type == 1 || this.sms_type == 2"
            type="primary"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('2040') : false
            "
            @click="quickReminderBtn"
            >快速提醒{{ this.sms_type == 1 ? "接诊" : "取药" }}</el-button
          >
          <el-form
            :model="ruleSmsForm"
            :rules="smsRules"
            ref="ruleSmsFormRef"
            label-width="100px"
            class="returnVisit-demo-ruleSmsForm"
          >
            <el-form-item label="接收人" prop="user_type">
              <el-radio-group
                v-model="ruleSmsForm.user_type"
                @change="userTypeChange"
              >
                <el-radio :label="1" :disabled="visitType == 2">医生</el-radio>
                <el-radio :label="3" :disabled="visitType == 2">业务</el-radio>
                <el-radio :label="2" :disabled="visitType == 1">患者</el-radio>
                <el-radio :label="4">其他</el-radio>
                <el-form-item
                  v-if="ruleSmsForm.user_type == 4"
                  label=""
                  prop="phone"
                  style="display: inline-block"
                >
                  <el-input
                    v-if="ruleSmsForm.user_type == 4"
                    v-model="ruleSmsForm.phone"
                    size="small"
                    style="width: 220px"
                  ></el-input>
                </el-form-item>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="短信内容" prop="content" class="content-item">
              <el-input
                type="textarea"
                v-model="ruleSmsForm.content"
                :rows="6"
                placeholder="请输入短信内容"
                maxlength="500"
                show-word-limit
              ></el-input>
              <div style="line-height: 20px">
                引用医生姓名请使用${doctor_name}、引用患者姓名请使用${user_name}、引用开方日期请使用${pre_time}、引用问诊发起日期请使用${con_time}
              </div>
              <div class="import-btn">
                <el-button type="primary" size="small" @click="is_show = true"
                  >导入模板内容</el-button
                >
              </div>
            </el-form-item>
            <el-form-item v-if="is_show" label="模板标题" prop="sms_title">
              <el-select
                v-model="selectContent"
                filterable
                remote
                reserve-keyword
                placeholder="请输入短信模板标题"
                :remote-method="getSmsTemplate"
                @change="changeSelect"
                :loading="loading"
              >
                <el-option
                  v-for="item in options"
                  :key="item.tcm_id"
                  :label="item.sms_title"
                  :value="item.sms_content"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item style="text-align: center; padding-right: 100px">
              <el-button size="small" @click="submitForm('ruleSmsFormRef', 1)"
                >保 存</el-button
              >
              <el-button
                size="small"
                type="primary"
                @click="submitForm('ruleSmsFormRef', 2)"
                >确定并继续</el-button
              >
            </el-form-item>
          </el-form>
          <!-- 短信记录 -->
          <el-divider content-position="left">短信发送记录</el-divider>
          <div style="border: 1px solid #f5f5f5">
            <el-table
              ref="smsLogTableRef"
              :data="smsLogTableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column label="接受人" prop="user_type" align="center">
                <template slot-scope="scope">
                  {{ scope.row.user_type | userTypeText }}
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="内容"
                prop="sms_content"
                align="center"
                width="500"
              >
              </el-table-column>
              <el-table-column label="发送时间" prop="send_time" align="center">
                <template slot-scope="scope">
                  {{ scope.row.send_time | dateFormat }}
                </template>
              </el-table-column>
              <el-table-column label="操作人" prop="user_name" align="center">
                <template slot-scope="scope">
                  {{ scope.row.user_name }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import _ from "lodash";
import dayjs from "dayjs";
import common from "../../api/common";
export default {
  props: [
    "isFlag",
    "businessId",
    "visitType",
    "visitName",
    "activeIndexDia",
    "sms_type",
    "typeList",
  ],
  data() {
    // let checkUserType = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('请选择'));
    //   } else if (!this.ruleSmsForm.phone && value ) {
    //     return callback(new Error('请输入手机号'));
    //   } else {
    //     return callback();
    //   }
    // };
    return {
      typeListData: this.typeList,
      active: 1,
      activeIndex: "1",
      dialogdata: false,
      doctor_info: {},
      patient_info: {},
      pre_info: {},
      consult_info: {},
      patient_pre_info: [],
      methodList: [],
      problemList: [],
      user_name: this.$store.state.userInfo.userInfo.real_name
        ? this.$store.state.userInfo.userInfo.real_name
        : this.$store.state.userInfo.userInfo.user_name,
      doctorLabel: [],
      patientLabel: [],
      totalNum: 0,
      tableData: [],
      ruleForm: {
        return_object: "",
        return_business_id: "",
        return_from: 1,
        visit_type: "",
        solving_type: "",
        desc: "",
        treatment_method: "",
        // is_on_return: 0,
        // next_time: '',
        return_type_min: "",
        visit_label: [],
      },
      rules: {
        return_object: [
          { required: true, message: "请选择回访对象", trigger: "blur" },
        ],
        visit_type: [
          { required: true, message: "请选择回访方式", trigger: "blur" },
        ],
        return_type_min: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        solving_type: [
          { required: true, message: "请选择处理问题类型", trigger: "blur" },
        ],
        treatment_method: [
          { required: true, message: "请填写回访结果", trigger: "blur" },
        ],
      },
      // 短信
      smsLogTableData: [],
      is_show: false,
      ruleSmsForm: {
        phone: undefined,
        sms_type: this.sms_type,
        sms_type_id: this.businessId,
        user_type: 1,
        user_type_name: "",
        content: "",
      },
      smsRules: {
        // user_type: [
        //   { required: true, validator: checkUserType, trigger: 'blur' }
        // ],
        user_type: [{ required: true, message: "请选择", trigger: "change" }],
        content: [{ required: true, message: "请输入", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^(1[3456789])\d{9}$/,
            message: "请输入正确手机号",
            trigger: "blur",
          },
        ],
      },
      selectContent: "",
      options: [],
      loading: false,
    };
  },
  watch: {
    isFlag() {
      this.dialogdata = true;
    },
    visitType: {
      handler(newValue, oldValue) {
        switch (newValue) {
          case 1:
            this.ruleSmsForm.user_type = 1;
            break;

          case 2:
            this.ruleSmsForm.user_type = 2;
            break;

          default:
            this.ruleSmsForm.user_type = 1;
            break;
        }
      },
      deep: true,
      immediate: true,
    },
    typeList: {
      handler(n, oldValue) {
        let visit_type = "";
        switch (this.visitType) {
          case 1:
            visit_type = "doctor";
            break;
          case 2:
            visit_type = "patient";
            break;
          case 3:
            visit_type = "prescription";
            break;
          case 4:
            visit_type = "consult";
            break;
        }
        if (!n || !n.length) {
          this.getVisitType(visit_type);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  filters: {
    userTypeText(val) {
      // 1医生2业务员3患者4其他
      switch (val) {
        case 1:
          return "医生";
        case 2:
          return "患者";
        case 3:
          return "业务员";
        case 4:
          return "其他";
      }
    },
    consultInfoStatusText(val) {
      switch (val) {
        case 0:
          return "未支付";
        case 1:
          return "待补充信息";
        case 2:
          return "待接诊";
        case 3:
          return "已接诊";
        case 4:
          return "拒绝接诊";
        case 5:
          return "问诊时间结束";
        case 6:
          return "超时未接诊";
        case 7:
          return "手动结束";
        case 8:
          return "超时未发起";
        case 9:
          return "医生退款结束";
        case 10:
          return "平台退款结束";
        case 11:
          return "未接诊平台退款结束";
        case 12:
          return "未接诊患者取消";
      }
    },
    dateFormat(val) {
      return dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    //获取回访类型
    getVisitType(visit_type) {
      // console.log(visit_type);
      this.axios
        .post("platform/Clientreview/getVisitType", { visit_type })
        .then((res) => {
          if (res.code == 0) {
            this.typeListData = res.data.list;
          }
        });
    },
    // 获取短信记录
    getBusinessSmsLog() {
      let params = {
        sms_type: this.sms_type,
        sms_type_id: this.businessId,
      };

      common.getBusinessSmsLog(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.smsLogTableData = data.list;
        }
      });
    },
    userTypeChange(val) {
      if (val != 4) {
        this.$refs["ruleSmsFormRef"].clearValidate("user_type");
      }
      switch (val) {
        case 1:
          this.ruleSmsForm.user_type_name = this.doctor_info.doctor_name;
          this.ruleSmsForm.phone = this.doctor_info.phone;
        case 2:
          this.ruleSmsForm.user_type_name = this.patient_info.real_name;
          this.ruleSmsForm.phone = this.patient_info.phone;
          break;
        case 3:
          this.ruleSmsForm.user_type_name = this.doctor_info.recommender_name;
          this.ruleSmsForm.phone = this.doctor_info.re_phone;
          break;
        case 4:
          this.ruleSmsForm.user_type_name = "";
          this.ruleSmsForm.phone = undefined;
          break;
      }
    },
    getSmsTemplate(query) {
      if (query != "") {
        this.loading = true;
        common
          .getSmsTemplate({ sms_title: query })
          .then((res) => {
            let { code, data } = res;
            if (code === 0) {
              this.options = data.list;
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.options = [];
      }
    },
    // type 1:保存关闭，2保存不关闭
    submitForm(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = _.cloneDeep(this.ruleSmsForm);
          params.sms_type = this.sms_type;
          params.sms_type_id = this.businessId;
          switch (this.ruleSmsForm.user_type) {
            case 1:
              params.user_type_name = this.doctor_info.doctor_name;
              params.phone = this.doctor_info.phone;
              break;
            case 2:
              params.user_type_name = this.patient_info.real_name;
              params.phone = this.patient_info.phone;
              break;
            case 3:
              params.user_type_name = this.doctor_info.recommender_name;
              params.phone = this.doctor_info.re_phone;
              break;
            case 4:
              params.user_type_name = "";
              params.phone = this.ruleSmsForm.phone;
              break;
          }
          common.visitBySms(params).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success("发送成功");
              if (type == 2) {
                this.closeMessage();
                this.getBusinessSmsLog();
              } else {
                this.closeMessage();
                this.close();
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeSelect(val) {
      this.ruleSmsForm.content = val;
    },
    closeMessage() {
      this.ruleSmsForm = {
        phone: this.doctor_info.phone,
        sms_type: this.sms_type,
        sms_type_id: this.businessId,
        user_type: 1,
        user_type_name: "",
        content: "",
      };
      this.selectContent = "";
      this.$nextTick(() => {
        this.$refs["ruleSmsFormRef"]
          ? this.$refs["ruleSmsFormRef"].resetFields()
          : "";
      });
    },
    // ******************************
    close() {
      this.dialogdata = false;
      this.activeIndex = "";
      this.closeMessage();
    },
    handleSelect(key) {
      this.active = Number(key);
      this.$forceUpdate();
    },
    openDialog() {
      this.activeIndex = this.activeIndexDia;
      this.active = Number(this.activeIndex);
      this.ruleForm = {
        return_object: "",
        return_business_id: "",
        return_from: 1,
        visit_type: "",
        solving_type: "",
        desc: "",
        treatment_method: "",
        // is_on_return: 0,
        // next_time: '',
        return_type_min: "",
        visit_label: [],
      };
      this.getDetail();
      this.getList();
      this.getVisitMethod();
      this.getVisitProblem();
      this.getVisitLabel();
      this.getBusinessSmsLog();
    },
    //获取回访方式
    getVisitMethod() {
      this.axios
        .post("platform/Admin/getVisitLabel", { label_name: "VISIT_METHOD" })
        .then((res) => {
          if (res.code == 0) {
            this.methodList = res.data;
          }
        });
    },
    //获取问题类型
    getVisitProblem() {
      this.axios
        .post("platform/Admin/getVisitLabel", { label_name: "PROBLEM_TPYE" })
        .then((res) => {
          if (res.code == 0) {
            this.problemList = res.data;
          }
        });
    },
    // 获取医生 /患者回访标签
    getVisitLabel() {
      this.axios
        .post("platform/Admin/getLabel", {
          type: 2,
          label_type: 3,
        })
        .then((res) => {
          if (res.code == 0) {
            this.doctorLabel = res.data.list;
          }
        });
      this.axios
        .post("platform/Admin/getLabel", {
          type: 1,
          label_type: 1,
        })
        .then((res) => {
          if (res.code == 0) {
            this.patientLabel = res.data.list;
          }
        });
    },
    //获取信息
    getDetail() {
      let data = {
        visit_type: this.visitName,
        visit_type_id: this.businessId,
      };
      this.axios
        .post("platform/Clientreview/getVisitInfo", data)
        .then((res) => {
          if (res.code == 0) {
            //医生
            if (this.visitType == 1) {
              this.doctor_info = res.data.doctor_info;
              this.doctor_info.create_time = this.doctor_info.create_time
                ? dayjs
                    .unix(this.doctor_info.create_time)
                    .format("YYYY-MM-DD HH:mm")
                : "";
              this.doctor_info.auth_time = this.doctor_info.auth_time
                ? dayjs
                    .unix(this.doctor_info.auth_time)
                    .format("YYYY-MM-DD HH:mm")
                : "";
            }
            //患者
            if (this.visitType == 2) {
              this.patient_info = res.data.patient_info;
            }
            //处方订单
            if (this.visitType == 3) {
              this.pre_info = res.data.pre_info;
              this.patient_pre_info = res.data.patient_pre_info.map((item) => {
                item.create_time = dayjs
                  .unix(item.create_time)
                  .format("YYYY-MM-DD HH:mm");
                return item;
              });
              this.patient_info = res.data.patient_info;
              this.doctor_info = res.data.doctor_info;
              this.doctor_info.create_time = this.doctor_info.create_time
                ? dayjs
                    .unix(this.doctor_info.create_time)
                    .format("YYYY-MM-DD HH:mm")
                : "";
              this.doctor_info.auth_time = this.doctor_info.auth_time
                ? dayjs
                    .unix(this.doctor_info.auth_time)
                    .format("YYYY-MM-DD HH:mm")
                : "";
            }
            //咨询
            if (this.visitType == 4) {
              this.consult_info = res.data.consult_info;
              this.patient_info = res.data.patient_info;
              this.doctor_info = res.data.doctor_info;
              this.consult_info.submit_time = this.consult_info.submit_time
                ? dayjs
                    .unix(this.consult_info.submit_time)
                    .format("YYYY-MM-DD HH:mm")
                : "";
              this.consult_info.agree_time = this.consult_info.agree_time
                ? dayjs
                    .unix(this.consult_info.agree_time)
                    .format("YYYY-MM-DD HH:mm")
                : "";
              this.consult_info.over_time = this.consult_info.over_time
                ? dayjs
                    .unix(this.consult_info.over_time)
                    .format("YYYY-MM-DD HH:mm")
                : "";
              this.doctor_info.create_time = this.doctor_info.create_time
                ? dayjs
                    .unix(this.doctor_info.create_time)
                    .format("YYYY-MM-DD HH:mm")
                : "";
              this.doctor_info.auth_time = this.doctor_info.auth_time
                ? dayjs
                    .unix(this.doctor_info.auth_time)
                    .format("YYYY-MM-DD HH:mm")
                : "";
            }
          }
        });
    },
    //获取列表
    getList() {
      let data = {
        return_type: this.visitType,
        return_from_business_id: this.businessId,
      };
      this.axios
        .post("platform/Clientreview/getHistoryVisitData", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              item.next_time = item.next_time
                ? dayjs.unix(item.next_time).format("YYYY-MM-DD")
                : "";
              return item;
            });
            this.totalNum = res.data.count;
          }
        });
    },
    //修改回访对象
    changeObject(value) {
      if (value == 1) {
        this.ruleForm.visit_label = this.doctor_info.customer_service_label
          ? this.doctor_info.customer_service_label.split(",")
          : [];
      }
      if (value == 2) {
        this.ruleForm.visit_label = this.patient_info.customer_service_label
          ? this.patient_info.customer_service_label.split(",")
          : [];
      }
    },
    //提交 type 1:保存关闭，2保存不关闭
    submit(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          data.return_type = this.visitType;
          data.return_from_business_id = this.businessId;
          data.label = data.visit_label.toString();
          let id_arr = [];
          //医生
          if (data.return_object == 1) {
            data.return_business_id = this.doctor_info.doctor_id;
            data.visit_label.map((item) => {
              let data = this.doctorLabel.find((ele) => {
                return ele.label_name == item;
              });
              if (data) {
                id_arr.push(data.label_id);
              }
            });
          }
          //患者
          if (data.return_object == 2) {
            data.return_business_id = this.patient_info.patient_id;
            data.visit_label.map((item) => {
              let data = this.patientLabel.find((ele) => {
                return ele.label_name == item;
              });
              if (data) {
                id_arr.push(data.label_id);
              }
            });
          }
          //处方订单
          if (data.return_object == 3) {
            data.return_business_id = this.doctor_info.recommender_code;
          }
          //药房
          if (data.return_object == 4) {
            data.return_business_id = this.pre_info.hospital_id;
          }
          //物流
          if (data.return_object == 5) {
            data.return_business_id = "";
          }
          data.label_id = id_arr.toString();
          this.axios
            .post("platform/Clientreview/saveVisitLog", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("已添加回访记录");

                if (type == 2) {
                  this.ruleForm = {
                    return_object: "",
                    return_business_id: "",
                    return_from: 1,
                    visit_type: "",
                    solving_type: "",
                    desc: "",
                    treatment_method: "",
                    // is_on_return: 0,
                    // next_time: '',
                    return_type_min: "",
                    visit_label: [],
                  };
                  this.getList();
                } else {
                  this.dialogdata = false;
                }
                this.$emit("refreshList");
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 快速提醒
    quickReminderBtn() {
      let params = {
        sms_type: this.sms_type,
        sms_type_id: this.businessId,
      };
      common.reminderBySms(params).then((res) => {
        if (res.code == 0) {
          this.getBusinessSmsLog();
          this.$message.success("已发送短信");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.return_visit {
  .container {
    padding: 20px;
    box-sizing: border-box;
    text-align: left;
  }
  .box {
    border: solid 1px #cfcece;
    padding: 10px;
    box-sizing: border-box;
    margin: 14px 0 20px;
  }
  .title {
    font-size: 15px;
    font-weight: 700;
  }
  .gray {
    color: #747981;
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 10px;
  }
  .gray_long {
    color: #747981;
    display: inline-block;
    width: 130px;
    text-align: right;
    margin-right: 10px;
  }

  .item {
    // flex: 1;
  }
  .input_width {
    width: 300px;
  }
  .phone-box {
    width: 18px;
    height: 18px;
    padding: 0 6px;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.return_visit .el-form-item {
  margin-bottom: 10px;
}
.return_visit .el-form-item__error {
  padding-top: 0px;
  margin-top: -3px;
}
.returnVisit-demo-ruleSmsForm {
  .content-item {
    position: relative;
    padding: 10px 0;
    .el-form-item__content {
      height: 170px;
    }
    .import-btn {
      position: absolute;
      bottom: 36px;
      right: 10px;
    }
  }
}
.clamp-line {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制在3行以内 */
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
